import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import smoothscroll from 'smoothscroll-polyfill'
// import { PersistGate } from 'redux-persist/integration/react'

import App from 'app/App'
import { store } from 'app/store/store'

// import { store, persistor } from 'app/store/store'
import './index.css'

// configure sentry
import './sentry'

smoothscroll.polyfill()

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
      <App />
      {/* </PersistGate> */}
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
